<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <v-data-table
              no-data-text="Нет аддресов"
              :headers="headers"
              :items="user.favorite_products"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка аддресов... Подождите пожалуйста"
      >
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
    // @ is an alias to /src


    import UserService from "../../../api/UserService";

    export default {
        name: 'Bonus',
        props: {
            value: Object,
            loading: Boolean,
            disabled: Boolean
        },
        data() {
            return {
                loadingButton: false,
                chargeItem: {
                  description: '',
                  count: 0
                },
                dialog: false,
                user: this.value,
                footerProps: {
                    itemsPerPageText: 'Адресов на страницу',
                    pageText: '',
                    itemsPerPageAllText: 'Все',
                    itemsPerPageOptions: [-1]
                },
                headers: [
                    {
                        text: 'Артикул',
                        value: 'code',
                        sortable: false,
                    },
                    {
                        text: 'Категория',
                        value: 'category.name',
                        sortable: false,
                    },
                    {
                      text: 'Блюдо',
                      value: 'name',
                      sortable: false,
                    },
                ],
            }
        },
        mounted() {
        },
        watch: {},
        methods: {

        }
    }
</script>

<style lang="scss">
  .category-svg{
    svg{
      width: 37px;
      height: 37px;
      path{
        stroke: #000
      }
    }
  }
  .grouped-row{
    background: #FAFCFF;
  }

</style>

<style lang="scss">
  .grouped-row {
    background: #FAFCFF;
  }

  .table-input {
    .v-input {
      height: 40px;
    }
  }
</style>
<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
